<template>
  <div>
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
      <h2 style="margin: 0;">文章/新闻管理</h2>
      <el-button type="text" icon="el-icon-plus" @click="$router.push('/admin/createarticle')">发布文章/信息</el-button>
    </div>
    <el-table :data="tableData" border>
      <el-table-column label="日期" width="170">
        <template slot-scope="scope">{{ scope.row.article_createtime | dataFormat }}</template>
      </el-table-column>
      <el-table-column label="标题" prop="article_title"></el-table-column>
      <el-table-column label="分类" prop="article_lable" width="120"></el-table-column>
      <el-table-column label="状态" width="120">
        <template slot-scope="scope">
          <span :class="{ 'text-green': scope.row.ispublic === 1, 'text-blue': scope.row.ispublic === 0, 'text-pink': scope.row.ispublic === -1 }">{{ scope.row.ispublic | statefilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="$router.push(`/admin/updataarticle/${scope.row.article_id}`)">编辑</el-button>
          <el-button type="text" style="color: #f56c6c;" @click="del(scope.row.article_id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center; margin-top: 16px;">
      <el-pagination
        background
        :total="total"
        :page-size="10"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="getlist"
        @size-change="(s) => { pagesize = s; getlist(1) }"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getMyArticleList, deleteArticle } from '@/api'

export default {
  name: 'ArticleList',
  filters: {
    statefilter(v) {
      return v === 1 ? '审核通过' : v === 0 ? '正在审核' : '审核未通过'
    }
  },
  data() {
    return { tableData: [], total: 0, pagesize: 10 }
  },
  created() {
    this.getlist(1)
  },
  methods: {
    getlist(page) {
      getMyArticleList({ page, pagesize: this.pagesize }).then((res) => {
        this.tableData = res.data || []
        this.total = res.count || 0
      })
    },
    del(id) {
      this.$confirm('确定删除这篇文章吗？', '提示', { type: 'warning' }).then(() => {
        deleteArticle(id).then(() => {
          this.$message.success('删除成功')
          this.getlist(1)
        })
      }).catch(() => {})
    }
  }
}
</script>
